import { Grid, NotificationBanner } from '@velocity/ui'
import { useCallback } from 'react'
import * as React from 'react'
import { Form } from 'react-final-form'

import { useContent } from '@ngb-frontend/shared/context'
import {
  DRIVER_STEP_FORM_ID,
  StepFooterDisabledSync,
} from '@ngb-frontend/shared/ui'
import {
  string,
  hasTruthyFields,
  validation as v,
} from '@ngb-frontend/shared/utils'

import { MalfunctionGroupsField } from '../../MalfunctionGroupsField/MalfunctionGroupsField'

import type {
  MalfunctionFormProps,
  MalfunctionFormValues,
} from '@ngb-frontend/shared/types'

export const MalfunctionForm: React.FC<MalfunctionFormProps> = ({
  onSubmit,
  initialValues,
  malfunctions,
}) => {
  const c = useContent()
  const handleSubmit = React.useCallback(
    (values: MalfunctionFormValues) => {
      const { malfunctionDescription } = values
      onSubmit?.({
        ...values,
        malfunctionDescription: string(malfunctionDescription),
      })
    },
    [onSubmit],
  )

  const validator = useCallback(
    (values: MalfunctionFormValues) => ({
      malfunctions: v.apply(v.minLength(1), {
        message: c('errors.malfunctionRequired'),
        type: 'errorType',
      })(
        string(values.malfunctionDescription) ||
          Object.values(values?.malfunctions || {}).flat(),
      ),
    }),
    [c],
  )

  return (
    <Form<MalfunctionFormValues>
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validate={validator}
    >
      {(formProps) => (
        <form
          id={DRIVER_STEP_FORM_ID}
          onSubmit={formProps.handleSubmit}
          data-e2e-component="malfunction-form"
        >
          <Grid margin={{ bottom: '07' }}>
            <Grid.Item>
              <MalfunctionGroupsField
                malfunctions={malfunctions}
                initialValues={initialValues}
                error={formProps.errors?.malfunctions}
                dirty={
                  hasTruthyFields(formProps.modified) || formProps.submitFailed
                }
              />
            </Grid.Item>
          </Grid>
          <NotificationBanner kind="information">
            {c('steps.malfunction.notCovered')}
          </NotificationBanner>
          <StepFooterDisabledSync disabled={formProps.invalid} />
        </form>
      )}
    </Form>
  )
}
